export const GET_PAYMENTS = "registrations/GET_PAYMENTS";
export const UPDATE_PAYMENTS = "registrations/UPDATE_PAYMENTS";
export const DELETE_PAYMENTS = "registrations/DELETE_PAYMENTS";